import { View } from '@play-co/timestep-core/ui';
import {
  particleStream,
  ParticleStreamNode,
} from 'src/lib/effects/particleStream';
import { getSceneManager } from 'src/lib/utils';

export async function animateCoins({
  superview,
  count,
  start,
  end,
}: {
  superview: View;
  count: number;
  start: ParticleStreamNode;
  end?: ParticleStreamNode;
}) {
  if (!getSceneManager()) {
    console.warn(
      'Could not play coin animation because scene manager is not available.',
    );
    return;
  }

  await particleStream({
    superview,
    start,
    end: end ?? {
      position: getSceneManager().header.getCoinIconPos(),
      scale: 0.5,
    },
    count: toParticleAmount(count),
    image: 'assets/ui/hud/icons/hud_coin.png',
    sfxBegin: 'progressCounted',
    sfxFinish: 'progressAwarded',
  });
}

export async function animateGems({
  superview,
  count,
  start,
  end,
}: {
  superview: View;
  count: number;
  start: ParticleStreamNode;
  end?: ParticleStreamNode;
}) {
  if (!getSceneManager()) {
    console.warn(
      'Could not play coin animation because scene manager is not available.',
    );
    return;
  }

  await particleStream({
    superview,
    start,
    end: end ?? {
      position: getSceneManager().header.getGemsIconPos(),
      scale: 0.5,
    },
    count: toParticleAmount(count),
    image: 'assets/ui/hud/icons/hud_gem.png',
    sfxBegin: 'progressCounted',
    sfxFinish: 'progressAwarded',
  });
}

export async function animateEnergy({
  superview,
  count,
  start,
  end,
}: {
  superview: View;
  count: number;
  start: ParticleStreamNode;
  end?: ParticleStreamNode;
}) {
  await particleStream({
    superview,
    start,
    end: end ?? {
      position: getSceneManager().header.getEnergyPos(),
      scale: 0.5,
    },
    count: count,
    image: 'assets/ui/hud/icons/hud_energy.png',
    sfxBegin: 'progressCounted',
    sfxFinish: 'progressAwarded',
  });
}

function toParticleAmount(num: number) {
  return Math.min(
    num / Math.max(Math.pow(10, Math.floor(Math.log10(num)) - 1), 1),
    30,
  );
}
